var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createAction, createSlice } from '@reduxjs/toolkit';
import { buildReducer } from '../utils/state';
export var initialState = [];
var HISTORY_TRACKED_STATE = [
    'providerEntity',
    'linkApi',
    'ddForm',
    'amountSelection',
];
var getTrackedStateRelevantData = function (state) {
    return HISTORY_TRACKED_STATE.reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[key] = state[key], _a)));
    }, {});
};
export var historySlice = createSlice({
    name: 'history',
    initialState: initialState,
    reducers: {},
}).reducer;
var historyReducer = buildReducer({
    'history/pushToHistory': function (state, action) { return (__assign(__assign({}, state), { history: __spreadArray([
            {
                pathname: action.payload,
                previousState: getTrackedStateRelevantData(state),
            }
        ], (state.history || []), true) })); },
    'history/popFromHistory': function (state) {
        var _a = state.history, previousHistory = _a[0], history = _a.slice(1);
        return __assign(__assign(__assign({}, state), previousHistory.previousState), { history: history });
    },
});
export var pushToHistory = createAction('history/pushToHistory');
export var popFromHistory = createAction('history/popFromHistory');
export var selectHistory = function (state) { return state.history; };
export var selectCurrentPath = function (state) { return state.history[0]; };
export default historyReducer;
